/// <reference path="Definitions/custom.d.ts" />
/// <reference path="Definitions/google.maps.d.ts" />
/// <reference path="Definitions/underscore.d.ts" />

import * as $modal from './_modal'
import * as $loading from './_loading'

export interface IInitOptions {
    pageName: string
    pageNameUnique: string
    pagePrefix: string
    link: string
}

let options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options

    $('.' + options.pageNameUnique + ' .' + options.pagePrefix + '-details').click(function () {
        $loading.show('Laddar detaljsida...')
        location.href = options.link
    })

    $('.' + options.pageNameUnique + ' .' + options.pagePrefix + '-close').click(function () {
        $modal.hide()
    })
}
